module.exports = __webpack_public_path__ + "img/person.67d848c1.svg";